// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1bkRk","text":"SelectPayment_text__2-aEC","title":"SelectPayment_title__jNztI","btn":"SelectPayment_btn__3gljF"};